import FJAppConstant from '../../constants/FJAppConstant';
import FJUtil from '../../util/FJUtil';
import {
    setSliceCurrentTime,
    setSliceTotalTime,
    setSliceUnitConversion,
    setSliceMaxUnitConversion,
    setSliceMinUnitConversion,
    setSliceContainerWidth,
} from '../slices/FJSliceTimeLine';
import FJActionRightTextBaseEditing from './textBasedEditing/FJActionRightTextBaseEditing.js';

const FJActionTimeLine = {
    setCurrentTimeAction: currentTime => {
        return setSliceCurrentTime(currentTime);
    },
    setTotalTimeAction: totalTime => {
        return setSliceTotalTime(totalTime);
    },
    setUnitConversionAction: unitConversion => {
        return function (dispatch, getState) {
            dispatch(setSliceUnitConversion(unitConversion));

            const appType = getState().common.appType;

            // 如果是AI文本编辑，则需要更新缩略图
            if (appType === FJAppConstant.AI_TEXT_BASED_EDITING) {
                setTimeout(() => {
                    dispatch(FJActionRightTextBaseEditing.updateThumbnailAction());
                }, 100);
            }
        };
    },

    /**
     * @desc 更新单位转换
     * @param {number} containerWidth 容器宽度
     */
    updateUnitConversionAction: function (newContainerWidth, isResetUnitConversion = true) {
        return (dispatch, getState) => {
            const { minWidthScale, maxWidthScale, unitConversion, containerWidth, totalTime } = getState().timeLine;

            const minWidth = newContainerWidth * minWidthScale;
            const maxWidth = newContainerWidth * maxWidthScale;

            const minUnitConversion = minWidth / totalTime;
            const maxUnitConversion = maxWidth / totalTime;

            if (isResetUnitConversion) {
                const newUnitConversion = FJUtil.getValueInRange(
                    newContainerWidth / totalTime,
                    minUnitConversion,
                    maxUnitConversion,
                );

                dispatch(this.setUnitConversionAction(newUnitConversion));
            } else {
                const newUnitConversion = unitConversion * (newContainerWidth / containerWidth);

                dispatch(this.setUnitConversionAction(newUnitConversion));
            }

            dispatch(setSliceMinUnitConversion(minUnitConversion));
            dispatch(setSliceMaxUnitConversion(maxUnitConversion));
            dispatch(setSliceContainerWidth(newContainerWidth));
        };
    },

    /**
     * @desc 适应缩放和位置
     */
    fitUnitConversionAndPositionAction: function () {
        return (dispatch, getState) => {
            const { containerWidth, totalTime } = getState().timeLine;

            const newUnitConversion = containerWidth / totalTime;

            dispatch(this.setUnitConversionAction(newUnitConversion));
        };
    },
};

export default FJActionTimeLine;
